<div id="searchContainer">
  <input type="text"[(ngModel)]="text" placeholder="{{ 'Shell.generic.search' | translate }}" [style.width.rem]="width" #searchText />
  <div id="magnifierGlass">&#8981;</div>
</div>
